<template>
  <div class="w-100 d-flex flex-row mt-4 mb-1">
    <div class="container-fluid my-3">
      <!-- mobile -->
      <div
        class="d-flex d-md-none row category-content mb-4"
        id="categorycarousel"
      >
        <div class="owl-carousel owl-theme" :id="'categoryCarousel'">
          <div
            class="item px-1"
            v-for="(item_cat, index) in category"
            :key="'cat  - ' + index"
          >
            <div
              class="item-cat cursor-pointer"
              @click="goTo(item_cat.link)"
              :class="item_cat.bg_color"
            >
              <span>{{ item_cat.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- desktop -->
      <div
        class="d-none d-md-flex row mr-0 category-content justify-content-center mb-5"
      >
        <div
          class="item px-2 my-2"
          v-for="(item_cat, index) in category"
          :key="'cat  - ' + index"
        >
          <div
            class="item-cat cursor-pointer"
            @click="goTo(item_cat.link)"
            :class="item_cat.bg_color"
          >
            <span>{{ item_cat.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
export default {
  data: function() {
    return {
      category: [],
      colors: ["bg-1", "bg-2", "bg-3", "bg-4", "bg-5", "bg-6", "bg-2"],
    };
  },
  props: ["obj", "cat_id"],
  methods: {
    initializeContentForStart() {
      var vm = this;
      var catArray = vm.obj;

      catArray.forEach((items, index) => {
        var link, random_color;

        // const random_color = Math.floor(Math.random() * vm.colors.length)
        vm.colors.forEach((color, idx) => {
          if (index == idx) {
            random_color = color;
          } else if (index > vm.colors.length) {
            random_color = vm.colors[index - 7];
          }
        });

        link =
          "/viewall?cat=" +
          vm.convertStringToLower(items.replace(/\s/g, "")) +
          "&contenttype=podcast&cat_id=" +
          this.cat_id[index];
        vm.category.push({
          name: items,
          link: link,
          bg_color: random_color,
        });

        if (index <= catArray.length - 1) {
          setTimeout(
            function() {
              Vue.nextTick(
                function() {
                  vm.installOwlCarousel("#categoryCarousel");
                }.bind(vm)
              );
            }.bind(this),
            600
          );
        }
      });

      // console.log(JSON.stringify(this.category, null, 2))
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    goTo(link) {
      this.$router.push(link);
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-lg"></span>',
          '<span class="fa fa-chevron-right fa-lg"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 0,
            stagePadding: 24,
          },
          720: {
            items: 5,
            nav: false,
            margin: 8,
            stagePadding: 2,
          },
        },
      });
    },
  },
  beforeMount() {
    this.initializeContentForStart();
  },
};
</script>

<style scoped>
.item {
  overflow: hidden;
}
.item-cat {
  width: fit-content;
  border-radius: 50px;
  padding: 16px 22px;
  max-width: 200px;
}
.item-cat span {
  color: white;
  font-size: 20px;
  font-weight: bold;
  line-height: 18px;
  display: flex;
  align-items: center;
  font-family: "Poppins", sans-serif !important;
}
.bg-1 {
  background: #e74c3c;
}
.bg-2 {
  background: #8e44ad;
}
.bg-3 {
  background: #3498db;
}
.bg-4 {
  background: #16a085;
}
.bg-5 {
  background: #f1c40f;
}
.bg-6 {
  background: #d35400;
}
.bg-7 {
  background: #bdc3c7;
}
.bg-8 {
  background: #f5b7b1;
}

@media only screen and (max-width: 992px) {
  .item-cat span {
    font-size: 16px;
  }
}
@media only screen and (max-width: 768px) {
  .item-cat {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }
  .item-cat span {
    font-size: 14px;
  }
}
</style>

<style>
#categorycarousel .owl-theme .owl-stage-outer {
  overflow: hidden;
}

@media only screen and (min-width: 992px) {
  #categorycarousel .owl-theme .owl-stage-outer:hover {
    overflow: unset;
  }

  #categorycarousel .owl-theme {
    height: 200px;
  }
}

#categorycarousel .owl-prev,
#categorycarousel .owl-next {
  max-height: 100px;
  top: 30% !important;
  width: 40px;
  position: absolute;
}

#categorycarousel .owl-prev,
#categorycarousel .owl-next {
  width: 50px !important;
  height: 50px !important;
}

#categorycarousel .owl-prev span,
.owl-next span {
  color: #fab900 !important;
}

#categorycarousel .owl-prev {
  left: -14px !important;
  background-image: linear-gradient(to right, #000000, rgba(0, 0, 0, 0));
}

#categorycarousel .owl-next {
  right: -14px !important;
  background-image: linear-gradient(to left, #000000, rgba(0, 0, 0, 0));
}

button:focus {
  outline: unset !important;
}

@media only screen and (max-width: 992px) {
  #categorycarousel .owl-prev,
  #categorycarousel .owl-next {
    top: 50px !important;
  }

  #categorycarousel .owl-prev,
  #categorycarousel .owl-next {
    width: 40px !important;
    height: 40px !important;
    font-size: 14px;
  }
}
@media only screen and (max-width: 768px) {
  #categorycarousel .owl-prev,
  #categorycarousel .owl-next {
    top: 40px !important;
  }
}
@media only screen and (max-width: 600px) {
  #categorycarousel .owl-prev,
  #categorycarousel .owl-next {
    top: 32% !important;
  }
}
@media only screen and (max-width: 480px) {
  #categorycarousel .owl-prev,
  #categorycarousel .owl-next {
    top: 25% !important;
  }
}
</style>
